import { MathUtils } from 'three';
import { useMemo } from 'react';
import { composeColor, decomposeColor } from '../../../utils/ColorUtils';

export default function useLerpedHexColor(from: number, to: number, t: number): number
{
  const fromRGB = useMemo(() => decomposeColor(from), [ from ]);
  const toRGB = useMemo(() => decomposeColor(to), [ to ]);

  return useMemo(() =>
  {
    return composeColor(
      MathUtils.lerp(fromRGB.r, toRGB.r, t),
      MathUtils.lerp(fromRGB.g, toRGB.g, t),
      MathUtils.lerp(fromRGB.b, toRGB.b, t)
    );
  }, [fromRGB, t, toRGB]);
}